<style lang="scss">
// @import "@/dependencies.scss";
</style>

<template>
  <div>
    <h2 class="text-h5 font-weight-regular text-uppercase black--text ">
      Vaata standardlahendusega näidiskorteri pilte
    </h2>
    <ul class="text-subtitle-1 my-2">
      <li>
        Palume tähelepanu pöörata ventilatsioonitorude jaoks allalastud lagedele ja kipskastidele
        tubades.
      </li>
      <li>
        Jahutusagregaat näidiskorteri ruumi seinas ei kuulu standardlahendusse - telli see lisana.
      </li>
    </ul>
    <ImageGallery title="" :items="$store.state.options.standard_apartment_images" />
  </div>
</template>

<script>
import ImageGallery from "./ImageGallery";
export default {
  components: {
    ImageGallery,
  },
};
</script>
